import React, { useState, useEffect, Fragment } from 'react';
import { Form } from 'react-final-form';
import {
  // required,
  // number,
  useDataProvider,
  useNotify,
  cacheDataProviderProxy,
} from 'react-admin';
import { DialogActions, DialogContent } from '@material-ui/core';
import {
  ReferenceInput,
  CheckboxInput,
  handleNumbers,
  getDateInputValue,
} from '../modalForms';
import { useGetUserRoles } from '../../../../hooks';
import { InfoPopup } from '../../InfoPopup';
import { SaveButton } from '../../../../design';
import { useStyles } from '../modal.styles';

export const EditCase = ({
  caseId,
  record = {},
  handleClose,
  closeAside,
  refresh,
}) => {
  const { is_admin, is_supervisor } = useGetUserRoles();
  const classes = useStyles();
  const dataProvider = cacheDataProviderProxy(useDataProvider());
  const notify = useNotify();
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (record) {
      const {
        id,
        end_resident_status_id,
        end_date,
        auth_check_override,
        case_status,
      } = record;
      setFormData(f => ({
        ...f,
        id,
        end_resident_status_id,
        end_date,
        auth_check_override,
        case_status,
      }));
    }
  }, [record]);

  const onSubmit = value => {
    return dataProvider
      .update('cases', {
        id: record.id,
        data: { ...value },
        previousData: { ...record },
      })
      .then(({ data }) => {
        notify('form.updated');
        handleClose();
        typeof refresh === 'function' && refresh();
      })
      .catch(error =>
        notify(
          typeof error === 'string'
            ? error
            : error.message || 'ra.notification.http_error',
          'warning',
        ),
      );
  };
  const customOnChange = async (eventOrValue, _name, type) => {
    // when using a react-admin input, onChange returns
    // the value instead of the target.
    let value = eventOrValue;
    let name = _name;
    if (typeof eventOrValue === 'object') {
      const target = eventOrValue.target;
      value = target.type === 'checkbox' ? target.checked : target.value;
      name = target.name;
    }
    if (type === 'number') {
      value = handleNumbers(value);
    }
    if (type === 'date') {
      value = getDateInputValue(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  return (
    <Fragment>
      <Form
        onSubmit={onSubmit}
        initialValues={{
          // ...caseFields,
          ...formData,
        }}
        render={({
          submitError,
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                {(is_admin ||
                  is_supervisor ||
                  formData.case_status === 'Unknown') && (
                  <ReferenceInput
                    fullWidth
                    reference='resident-statuses/list'
                    customOnChange={customOnChange}
                    name='end_resident_status_id'
                    label='Case Status'
                  />
                )}

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CheckboxInput
                    name='auth_check_override'
                    customOnChange={customOnChange}
                    label='Auth Check Override'
                    checked={values.auth_check_override}
                  />
                  <InfoPopup
                    maxWidth={300}
                    infoText='When this box is checked, the system will not review this case for missing auths.'
                  />
                </div>
              </DialogContent>
              <DialogActions
                className={classes.padding16}
                style={{ paddingBottom: 16 }}
              >
                <SaveButton
                  className={classes.saveButton}
                  disabled={submitting}
                  type='submit'
                />
              </DialogActions>
            </form>
          );
        }}
      />
    </Fragment>
  );
};
